export default ({
  state: {
    InsumosForm: [
      { field: 'searchDataServer', name: 'Buscar Insumo', nameid: 'insumo_id', url: '/insumos/picking', objecName: 'insumo', itemValue: 'id', rules: true, cols: 12 },
      { field: 'text', type: 'text', name: 'Cantidad', nameid: 'cantidad', rules: true, cols: 12 }
    ],
    incidenciaForm: [
      { field: 'selectGroupDataServer', name: 'Periodo', nameid: 'ejercicio_id', url: '/nomina/config/ejercicio/periodos', rules: true, cols: 12, default: true },
      { field: 'searchDataServer', name: 'Colaborador', nameid: 'adscripcion_id', url: '/nomina/empleados-plazas/find', itemValue: 'id', rules: true, cols: 12 },
      { field: 'number', type: 'number', name: 'Asistencia', nameid: 'horas_asistencia', cols: 6 },
      { field: 'number', type: 'number', name: 'Faltas', nameid: 'horas_faltas', cols: 6 }
    ],
    fileIncidencia: [
      { field: 'fileInputDataServer', name: 'Layout Incidenias', nameid: 'file', rules: true, cols: 12 }
    ],
    cuentasEmpleadosForm: [
      { field: 'searchDataServer', name: 'Colaborador', nameid: 'cve_empleado', url: '/rh/empleado/find', itemValue: 'cve_empleado', rules: true, cols: 12 },
      { field: 'selectDataServer', name: 'Banco', nameid: 'banco_id', url: '/nomina/bancos/show', rules: true, cols: 12 },
      { field: 'text', type: 'text', name: 'Cuenta Bancaria', nameid: 'cuenta', rules: false, cols: 6 },
      { field: 'text', type: 'text', name: 'Clabe Bancaria', nameid: 'clabe', rules: false, cols: 6 }
    ],
    usersForm: [
      { field: 'text', type: 'text', name: 'Nombre Usuario', nameid: 'usuario', rules: true, cols: 12 },
      { field: 'searchDataServer', name: 'Colaborador', nameid: 'cve_empleado', url: '/rh/empleado/find', itemValue: 'cve_empleado', rules: true, cols: 12 },
      { field: 'text', type: 'text', name: 'Correo Electronico', nameid: 'email', rules: true, cols: 12 },
      { field: 'text', type: 'password', name: 'Contraseña', nameid: 'password', rules: true, cols: 12 },
      { field: 'text', type: 'password', name: 'Confirmar Contraseña', nameid: 'confirmpassword', rules: true, cols: 12 }
    ],
    roleForm: [
      { field: 'text', type: 'text', name: 'Clave Role', nameid: 'slug', rules: true, cols: 12 },
      { field: 'text', type: 'text', name: 'Nombre Role', nameid: 'nombre', rules: true, cols: 12 }
    ],
    assignRoles: [
      { field: 'viewText', name: 'Nombre Colaborador', nameid: 'NombreCompleto', cols: 12 },
      { field: 'viewText', name: 'Nombre Usuario', nameid: 'usuario', cols: 12 },
      { field: 'viewTextList', name: 'Rol Asignado', nameid: 'roles', action: 'removeRole', color: 'info', itemnameid: 'nombre', cols: 12 },
      { field: 'selectDataServer', name: 'Rol', nameid: 'rol_id', url: '/config/auth/roles/show', rules: true, cols: 12 }
    ],
    updateAdscripcion: [
      { field: 'searchDataServer', name: 'Colaborador', nameid: 'cve_empleado', url: '/rh/empleado/find', cols: 12, rules: true, itemValue: 'cve_empleado', action: 'findBillEmployee', isHidden: ['cuenta_id'] },
      { field: 'selectDataServer', name: 'Cuenta', nameid: 'cuenta_id', url: '/nomina/cuentas/show', cols: 12, rules: true, default: '/nomina/cuentas/show-by-employee/', params: {}, hidden: true },
      { field: 'selectDataServer', name: 'Plaza', nameid: 'plaza_id', url: '/nomina/config/plazas/show', cols: 12, rules: true },
      { field: 'searchDataServer', name: 'Departamento', nameid: 'departamento_id', url: '/config/departamentos/find', cols: 12, rules: true, itemValue: 'id' }
    ],
    contactoForm: [
      { field: 'radioButton', name: 'Tipo Contacto', nameid: 'tipo', items: ['TELEFONO', 'CORREO', 'MOVIL'], rules: true, row: true, cols: 12 },
      { field: 'text', type: 'text', name: 'Contacto', nameid: 'contacto', rules: true, cols: 12 }
    ],
    direccionForm: [
      { field: 'text', type: 'text', name: 'Calle', nameid: 'calle', rules: true, cols: 3 },
      { field: 'text', type: 'text', name: 'Numero', nameid: 'numero', rules: true, cols: 3 },
      { field: 'text', type: 'text', name: 'Cruzamiento 1', nameid: 'cruzamiento1', rules: true, cols: 3 },
      { field: 'text', type: 'text', name: 'Cruzamiento 2', nameid: 'cruzamiento2', rules: true, cols: 3 },
      { field: 'text', type: 'text', name: 'Codigo postal', nameid: 'cp', rules: true, cols: 6 },
      { field: 'searchDataServer', name: 'Localidad', nameid: 'localidad_id', url: '/config/cat/localidad/find', itemValue: 'id', value: 'id', cols: 6 }
    ],

    MarcaForm: [
      { field: 'text', type: 'text', name: 'Nombre', nameid: 'nombre', rules: true, cols: 12 }
    ]
  },
  getters: {
    get_InsumosForm (state) { return state.InsumosForm },
    get_MarcaForm (state) { return state.MarcaForm }
  },
  mutations: {},
  actions: {}
})
